/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Gender_Diverse7Inputs */

const en__field__enum_gender_diverse7 = /** @type {(inputs: _Field__Enum_Gender_Diverse7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diverse`)
};

const de__field__enum_gender_diverse7 = /** @type {(inputs: _Field__Enum_Gender_Diverse7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divers`)
};

/**
* | output |
* | --- |
* | "Diverse" |
*
* @param {_Field__Enum_Gender_Diverse7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_gender_diverse7 = /** @type {((inputs?: _Field__Enum_Gender_Diverse7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Gender_Diverse7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_gender_diverse7(inputs)
	return de__field__enum_gender_diverse7(inputs)
});
export { _field__enum_gender_diverse7 as "_field__enum_gender_DIVERSE" }